export default __webpack_public_path__ + "20028446cca2114ce8912aa3253d63cf.svg";